import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {ModalController} from '@ionic/angular';
import {LocalStorageService} from '../../../_services';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {

  @Input() selectProjectMap = false;
  /*public projects: any = [
    {
      type: 'space',
      logo: '/assets/img/logo/light-CARINGSPACES.svg',
      name: 'CARINGSPACE'
    },
    {
      type: 'act',
      logo: '/assets/img/logo/youact.svg',
      name: 'YOUACT'
    },
    {
      type: 'ic',
      logo: '/assets/img/logo/LOGO-IC.svg',
      name: 'INVISIBLECITY'
    },
    {
      type: 'yarn',
      logo: '/assets/img/logo/LOGO-YC.svg',
      name: 'YARNCOUNTRY'
    },
    {
      type: 'paint',
      logo: '/assets/img/logo/LOGO-PR.svg',
      name: 'PAINTEDRIVER'
    },
    {
      type: 'codeRed',
      logo: '/assets/img/logo/LOGO-CR.svg',
      name: 'CODERED'
    },
    {
      type: 'ap',
      logo: '/assets/img/logo/LOGO-AP.svg',
      name: 'ALLPROJECTS'
    }
  ];*/
  projects: any[] = [];

  constructor(public translate: TranslateService,
              private localStorageService: LocalStorageService,
              private modalController: ModalController,
              private router: Router) {
    this.projects = this.localStorageService.get('project_list');
  }

  ngOnInit() {
  }

  selectProject(project) {
    if (this.selectProjectMap) {
      this.modalController.dismiss(project);
      return;
    }
  }

  back() {
    this.modalController.dismiss();
  }

  dismiss(): void {
    this.modalController.dismiss();
  }
}
